module.exports = __webpack_public_path__ + "img/content.2964df92.gif";